import * as React from 'react';
import { Button, Divider, Form, Modal, Progress, Row } from 'antd';
import { L } from '../../../../lib/abpUtility';
//import { L } from '../../../lib/abpUtility';


export interface ISignOutDrawerProps {
  visible: boolean;
  primaryColor: string;
  secondaryColor: string;
  onCancel: () => void;
  location: any;
  isMobile: boolean;
}


export class SignOutDrawer extends React.Component<ISignOutDrawerProps> {

  state = {

  };

  signOut = () => {
    const { state } = this.props.location;
    window.location = state ? state.from.pathname : '/#/logout';

  };


  render() {
    const { visible, onCancel } = this.props;

    return (

      <div>


 
          <Modal
            closable={window.innerWidth < 650 ? true : false}
            cancelText={L('Cancel')}
            footer={null}
            open={visible}
            width={400}
            onCancel={onCancel}
            title={null}>
            <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
              {L('Sign Out?')}
            </Divider>
            <Row style={{ marginBottom: '15px' }}>
              <Progress
                strokeColor={{
                  from: this.props.secondaryColor,
                  to: this.props.primaryColor,
                }}
                showInfo={false}
                percent={100}
                status="normal"
                size={'small'}
              />
            </Row>




            <div style={{ margin: 'auto', width: '160px', textAlign: 'center',  marginBottom: '10px'  }}>
              <Form.Item style={{ margin: 'auto', float: 'left', marginRight: '10px' }}>
                <Button style={{ borderColor: this.props.primaryColor }}
                  size='large' type="default" shape='round' htmlType="submit"
                  onClick={this.signOut}
                  className="font-face-gm">
                  {L('OK')}
                </Button>
              </Form.Item>
              <Form.Item style={{ margin: 'auto',  }}>
                <Button style={{ background: this.props.secondaryColor, borderColor: 'white', }} size='large' type="primary" shape='round' onClick={onCancel} className="font-face-gm">
                  {L('Cancel')}
                </Button>
              </Form.Item>
            </div>




          </Modal>

      


      </div>
    );
  }
}

export default SignOutDrawer;
